# GraphQL mutation to enable/disable Office365 email sync
#import "../fragments/user-email-fragment.graphql"

mutation setOffice365MailSyncIsEnabled(
    $isEnabled: Boolean!
    $fromDaysAgo: Int
    $createContacts: Boolean
) {
    setOffice365MailSyncIsEnabled(
        input: {
            mailSync: {
                isEnabled: $isEnabled
                initialSyncStartFromDaysAgo: $fromDaysAgo
                initialSyncCreateContacts: $createContacts
            }
        }
    ) {
        authUrl
        emailAddresses {
            ...UserEmail
        }
    }
}
